<div class="myprofile">
  <!-- Imagen de fondo -->
  <div class="background-image"></div>

  <!-- Overlay oscuro -->
  <div class="overlay-dark"></div>

  <!-- Contenedor de contenido -->
  <div class="overlay">
    <!-- Título principal -->
    <div class="title-section">
      <h1 class="main-title">BIEN-ESTAR</h1>
    </div>

    <!-- Texto dinámico con palabras rotativas -->
    <div class="intro-text">
      <span class="highlight">{{ currentWord }}</span>
    </div>

    <!-- Botón central -->
    <button class="consultation-btn btn-96" (click)="openWhatsApp()">
      <span>Quiero una consulta</span>
    </button>
  </div>

</div>

<app-habilidades></app-habilidades>
<app-projects></app-projects>
<app-psychologists-section></app-psychologists-section>
<app-aboutme></app-aboutme>
<app-cursos></app-cursos>
<app-faq></app-faq>
<!--<app-experiences></app-experiences>-->
<!--<app-tech></app-tech>-->
<app-contact></app-contact>

<!-- Acciones flotantes: chatbot arriba, WhatsApp abajo.
     Siempre visibles durante todo el scroll. -->
<div class="floating-actions">

  <!-- Activo cuando la API del chatbot está configurada (environment.chatbotApiUrl). -->
  <app-chatbot></app-chatbot>

  <div class="floating-btn-wrapper">
    <button type="button" class="whatsapp-float" title="Contactar por WhatsApp" aria-label="Contactar por WhatsApp"
      (click)="openWhatsApp()">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="whatsapp-icon" aria-hidden="true">
        <path d="M12 2C6.48 2 2 6.48 2 12c0 1.54.36 3 .97 4.29L2.5 22l6.05-1.59c1.26.74 2.71 1.17 4.45 1.17 5.52 0 10-4.48 10-10S17.52 2 12 2zm0 18c-1.41 0-2.73-.36-3.88-.99l-.28-.15-2.89.76.78-2.86-.18-.28C4.25 15.48 4 13.8 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8zm3.86-6.14c-.23-.12-1.36-.67-1.57-.74-.21-.07-.36-.11-.52.11-.16.23-.62.74-.76.9-.14.15-.29.17-.52.05-.23-.12-1.01-.37-1.91-1.18-.71-.63-1.18-1.41-1.32-1.64-.14-.23-.02-.36.1-.48.1-.1.23-.26.35-.39.12-.13.16-.22.23-.37.08-.15.04-.28-.02-.39-.06-.11-.52-1.25-.71-1.71-.19-.45-.38-.39-.52-.39h-.46c-.16 0-.43.06-.66.29-.23.23-.88.86-.88 2.1 0 1.24.9 2.43 1.03 2.6.13.17 1.83 2.79 4.43 3.91.62.27 1.1.42 1.48.54.62.2 1.19.17 1.64.1.5-.08 1.55-.63 1.77-1.24.22-.61.22-1.13.15-1.23-.07-.1-.22-.16-.46-.28z"/>
      </svg>
    </button>
    <div class="float-label" aria-hidden="true">Contáctame ahora</div>
  </div>

</div>